import {UmpireSquad} from '../umpire-squad';
import {UmpireMatchStat} from '../umpire-match-stat';

export interface UmpireMatchStats {
  type: string;

  id: string;

  start_time: string | undefined;

  stats: UmpireMatchStat[] | undefined;

  home_squad: UmpireSquad | undefined;

  away_squad: UmpireSquad | undefined;
}
